import { render, staticRenderFns } from "./SofAddTemplate.vue?vue&type=template&id=94929566&scoped=true&"
import script from "./SofAddTemplate.vue?vue&type=script&lang=js&"
export * from "./SofAddTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SofAddTemplate.vue?vue&type=style&index=0&id=94929566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94929566",
  null
  
)

export default component.exports